import { HStack } from '@chakra-ui/react';
import { BedrockColors } from 'chakra-ui/bedrockTheme';
import { ApplicationsStatusFilterEnum } from './ApplicationsStatusFilter';
import FilterButton from './FilterButton';

const ApplicationsFilters = ({ setPage, selectedStatus, setSelectedStatus, metrics }) => {
  const total = metrics?.numCompletedApps + metrics?.numPendingApps + metrics?.numFailedApps;

  const filters = [
    {
      label: 'All Applications',
      value: total,
      status: '',
      tooltip: 'All applications received within the last 30 days.',
    },
    {
      label: 'Complete Applications',
      value: metrics?.numCompletedApps,
      status: ApplicationsStatusFilterEnum.COMPLETED,
      tooltip: 'All applications received in the last 30 days that were accepted.',
    },
    {
      label: 'Pending Applications',
      value: metrics?.numPendingApps,
      status: ApplicationsStatusFilterEnum.PENDING,
      tooltip: 'All applications received in the last 30 days that are still being processed.',
    },
    {
      label: 'Failed Applications',
      value: metrics?.numFailedApps,
      status: ApplicationsStatusFilterEnum.FAILED,
      tooltip: 'All applications received in the last 30 days that failed.',
    },
  ];

  return (
    <HStack gap={16} color={BedrockColors.primary}>
      <HStack spacing={6}>
        {filters.map((filter) => (
          <FilterButton
            key={filter.label}
            selectedStatus={selectedStatus}
            setSelectedStatus={setSelectedStatus}
            setPage={setPage}
            {...filter}
          />
        ))}
      </HStack>
    </HStack>
  );
};

export default ApplicationsFilters;
